<script>
import analyticsService from '@utils/analytics-service'
import { authMethods, authMutations } from '@state/helpers'

export default {
  page: {
    title: 'App Login',
    meta: [{ name: 'description', content: 'The App Login page.' }],
  },
  props: {
    allParams: {
      type: Object,
      default: () => { return {} }
    }
  },
  async mounted() {
    analyticsService.trackPageView('App Login')

    await this.SET_APP_LOGIN(true)

    const isRealUser = this.allParams.token;
    const destinationRoute = this.allParams.destinationRoute;

    if (isRealUser) {
      console.log('is real user')
      const user = {token: this.allParams.token}
      await this.SET_CURRENT_USER(user)
    } else {
      console.log('setting user to null')
      await this.SET_CURRENT_USER(null)
    }

    const routeParams = this.allParams;
    delete routeParams.token;
    delete routeParams.destinationRoute;

    if (isRealUser) {
      console.log('validating user token')
      this.validate().then(() => {
        const body = {name: destinationRoute}
        if (Object.keys(routeParams).length > 0) {
          body.params = routeParams;
        }
        this.$router.push(body);
      });
    } else {
      console.log('navigating to', destinationRoute)
      const body = {name: destinationRoute}
      if (Object.keys(routeParams).length > 0) {
        body.params = routeParams;
      }
      await this.$router.push(body);
    }
  },
  methods: {
    ...authMethods,
    ...authMutations
  }
}
</script>

<template>
    <v-layout row wrap fill-height align-center>
      <v-flex style="text-align: center">
        <img
            class="img"
            src="@assets/images/loading_image.gif"
            alt="loading..."
            width="200"
        />
      </v-flex>
    </v-layout>
</template>

<style lang="scss" module>
#loading {
  position: absolute;
  z-index: 1000;
  background-color: white;
  height: 100vh;
  width: 100vw;
  text-align: center;
  line-height: 100vh;
}
.img {
  position: relative;
  margin: auto;
  margin-top: 20%;
}
</style>

